import React from 'react';
import { StyledConsentLink } from './ConsentLink.styles';

type ConsentLinkProps = Readonly<{
  href: string;
  children: React.ReactNode;
}>;

/**
 * A terms or privacy link inside a consent line: the line's own colour and size with a dotted
 * underline, opening in a new tab so the form behind it keeps what the guest has entered.
 *
 * Shared by every consent line in the event form so they look and behave alike. On a matched page,
 * `RegistrationFormTypographyProvider` keeps the hover colour in the page's text colour by targeting
 * `StyledConsentLink`.
 */
export const ConsentLink = ({ href, children }: ConsentLinkProps) => (
  <StyledConsentLink
    href={href}
    target="_blank"
    // Set here because LinkV2 only adds `noopener` for `isExternal`, and on its own adds `nofollow`.
    rel="noopener noreferrer"
    color="inherit"
    typographyVariant="label2"
    _hover={{ color: 'buttonPrimaryHover' }}
    _focusVisible={{ color: 'buttonPrimaryHover' }}
  >
    {children}
  </StyledConsentLink>
);
